import './ToggleSwitch.css';

function ToggleSwitch({ isOn, onToggle }) {
    return (
        <div className="toggle-button-group">
            <button
                className={`toggle-button ${isOn ? 'active' : ''}`}
                onClick={() => onToggle(true)}
            >
                Basic
            </button>
            <button
                className={`toggle-button ${!isOn ? 'active' : ''}`}
                onClick={() => onToggle(false)}
            >
                Pro +
            </button>
        </div>
    );
}

export default ToggleSwitch;